<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-0">
    <v-expansion-panel-header
      id="rec_pub_recs_req"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >Flying A Drone In Reno
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <v-card shaped class="mt-4">
        <v-card-title>
          <h4>Flying A Drone In Reno </h4>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 1.1rem !important;">
       <p>The RPD is not the appropriate point of contact for
        individuals seeking to fly drones or obtain approval for drone operations. 
        All approvals for drone operations must be obtained through the Federal
         Aviation Administration (FAA), the agency responsible for regulating 
         airspace and ensuring the safety of drone activities. Citizens are
          encouraged to consult the FAA's guidelines and approval processes to 
          comply with federal regulations before flying drones. Please consult the 
          LAANC app or the FAA Drone Zone for any authorizations. </p>
 
<a href="https://www.faa.gov/newsroom/what-know-about-drones"
style="color:#4DA3FF;font-size: 1.1rem !important;"
 target="_blank">External 
  link to the FAA for drone related questions/do's and don'ts</a> 
</div>
        </v-card-text>
      </v-card>

    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
border-img {
  border: 1px solid black;
}
.div-login-page-img {
  margin: 0;
}
.letter_img {
  width: 100%;
  margin-left: 0 !important;
}
.login-page-img {
  width: 100%;
  margin-left: 0 !important;
}
p {
  font-weight: 600;
  padding: 12px;
}
a {
  color: blue;
}
a:visited {
  color: rgb(2, 2, 32);
}
.bcs-expansion-content {
  color: black;
}
.basic-interior-card {
  min-height: 100px;
}
@media (min-width: 768px) {
  .login-page-img {
    max-width: 300px;
  }
  .letter_img {
    max-width: 436px;
  }
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "content2",
  mixins: [bus_common],
  data: function () {
    return {
      isActive1: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
